<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <CallSetUpTimeTopMenuButton ref='tsMenuButton' @methodEnum='methodEnum' ></CallSetUpTimeTopMenuButton>
      <div class="h100-100 h-scroll" style="padding-top: 30px;">
        <CallSetUpTimeChart ref='callSetUpTimeChart'></CallSetUpTimeChart>
      </div>
    </template>
  </BasicLayout>
</template>

<script>

import BasicLayout from '../../layouts/BasicLayout';
import CallSetUpTimeTopMenuButton from '../../components/tsConfig/CallSetUpTimeStatistics/CallSetUpTimeTopMenuButton';
import CallSetUpTimeChart from '../../components/tsConfig/CallSetUpTimeStatistics/CallSetUpTimeChart';

export default {
  name: 'CallSetUpTimeStatisticsPage',
  components: {
    BasicLayout,
    CallSetUpTimeTopMenuButton,
    CallSetUpTimeChart
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('TS.trafficMeasurement')}/${this.$t('TS.callServiceStatistics')}/${this.$t('TS.callSetUpTimeStatistics')}`
      }
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'search':
          this.$refs.callSetUpTimeChart.searchPage();
          break;
        default:
      }
    }
  }
};
</script>

<style scoped>

</style>
